// extracted by mini-css-extract-plugin
module.exports = {"cardGroup":"_af613a5"};